import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';
import { useLanguage } from '@/context/LanguageContext';

const SCHOOL_LOGO = 'https://customer-assets.emergentagent.com/job_89f0a926-232e-4f27-8bd9-23de150e4a0b/artifacts/ydf6w6ly_New%20St.%20Franic%20School%20Logo.jpg';

export default function Footer() {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-r from-blue-950 via-blue-900 to-blue-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* About Section */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <img
                src={SCHOOL_LOGO}
                alt="School Logo"
                className="h-12 w-12 rounded-full ring-2 ring-amber-500"
              />
              <div>
                <h3 className="text-lg font-bold">New St. Francis School</h3>
                <p className="text-xs text-amber-400">Education is Above All</p>
              </div>
            </div>
            <p className="text-sm text-blue-100 leading-relaxed">
              Established in 2002, we are committed to providing quality education and holistic development to young learners.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Quick Links</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-blue-100 hover:text-amber-400 transition-colors">About Us</Link></li>
              <li><Link to="/academics" className="text-sm text-blue-100 hover:text-amber-400 transition-colors">Academics</Link></li>
              <li><Link to="/achievements" className="text-sm text-blue-100 hover:text-amber-400 transition-colors">Achievements</Link></li>
              <li><Link to="/gallery" className="text-sm text-blue-100 hover:text-amber-400 transition-colors">Gallery</Link></li>
              <li><Link to="/contact" className="text-sm text-blue-100 hover:text-amber-400 transition-colors">Contact Us</Link></li>
            </ul>
          </div>

          {/* Portals */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Portals</h4>
            <ul className="space-y-2">
              <li><Link to="/student-portal" className="text-sm text-blue-100 hover:text-amber-400 transition-colors">Student Portal</Link></li>
              <li><Link to="/parent-portal" className="text-sm text-blue-100 hover:text-amber-400 transition-colors">Parent Portal</Link></li>
              <li><Link to="/teacher-dashboard" className="text-sm text-blue-100 hover:text-amber-400 transition-colors">Teacher Dashboard</Link></li>
              <li><Link to="/admin" className="text-sm text-blue-100 hover:text-amber-400 transition-colors">Admin Panel</Link></li>
              <li><Link to="/login" className="text-sm text-blue-100 hover:text-amber-400 transition-colors">Login</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4 text-amber-400">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2 text-sm text-blue-100">
                <MapPin className="w-5 h-5 flex-shrink-0 text-amber-400 mt-0.5" />
                <span>Manwani Colony, Behind Bank of India, Near Shivani Hotel, Pithampur, Dhar (M.P.) 454775</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-blue-100">
                <Phone className="w-5 h-5 text-amber-400" />
                <span>9827780604, 9755402604</span>
              </li>
              <li className="flex items-center space-x-2 text-sm text-blue-100">
                <Mail className="w-5 h-5 text-amber-400" />
                <span>nsfschool123@gmail.com</span>
              </li>
            </ul>

            {/* Social Media */}
            <div className="flex space-x-3 mt-4">
              <a href="https://www.facebook.com/share/18Lo4SnE3V/?mibextid=wwXIfr" className="p-2 rounded-full bg-blue-800 hover:bg-amber-500 transition-colors">
                <Facebook className="w-4 h-4" />
              </a>
              <a href="https://www.instagram.com/newstfrancishighschool?igsh=MTZ3cm8yd3YwdXdpeQ%3D%3D&utm_source=qr" className="p-2 rounded-full bg-blue-800 hover:bg-amber-500 transition-colors">
                <Instagram className="w-4 h-4" />
              </a>
              {/* <a href="#" className="p-2 rounded-full bg-blue-800 hover:bg-amber-500 transition-colors">
                <Twitter className="w-4 h-4" />
              </a>
              <a href="#" className="p-2 rounded-full bg-blue-800 hover:bg-amber-500 transition-colors">
                <Youtube className="w-4 h-4" />
              </a> */}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t border-blue-800">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0">
            <p className="text-sm text-blue-200">
              © {currentYear} New St. Francis School, Pithampur. All rights reserved. | Designed By <a href="https://wschools.co.in/">WSchools</a>
            </p>
            <div className="flex space-x-4 text-sm text-blue-200">
              <a href="#" className="hover:text-amber-400 transition-colors">Privacy Policy</a>
              <a href="#" className="hover:text-amber-400 transition-colors">Terms of Service</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}